(function (ws) {
    'use strict';

    ws.views.manualRMAreturnsShipping = ws.views.shipping.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'rma_activity',
        GTM_EVENT_ACTION: 'request rma step 2',

        /**
         * events
         */
        events: _.extend({}, ws.views.shipping.prototype.events, {
            'change .error': 'resetField',
            'change #country': 'onCountryChange',
            'change #addressBook': 'onSelectAddressBookChanged',
            'click #sameAsShipTo': 'hideAndShowPickUpAddress',
            'change #pickUpAddressBook': 'onSelectPickUpAddressBookChanged'
        }),

        hideAndShowPickUpAddress: function() {
            if (this.$('#sameAsShipTo').prop('checked')) {
                this.$('.pickup-address-type-fieldset').hide();
            } else {
                this.$('.pickup-address-type-fieldset').show();
            }
        },

        /**
         * Initialize
         */
        initialize: function () {
            ws.views.shipping.prototype.initialize.call(this);

            this.error = false;
            this.$faxField = this.$('input.fax');
            this.$wholeNumberField = this.$('input.wholeNumber');

            this.onCountryChange();
            this.hideAndShowPickUpAddress();
        },

        /**
         * On Country Change method
         */
        onCountryChange: function () {
            if (this.countries) {
                this.updateFieldsWithCountry(this.countries);
            } else {
                this.countries = new ws.models.shippingCountry();
                this.countries.fetch({
                    success: (response) => {
                        this.updateFieldsWithCountry(response);
                    }
                });
            }
        },

        updateValues: function () {
            if (!this.error) {
                $('#addressBook').val('null');
            }
        },

        /**
         * Additional field validations
         */
        additionalValidation: function () {
            if (this.$requiresShipping.val()) {
                ws.views.shipping.prototype.additionalValidation.call(this);
            }

            this.checkEmail();
            this.checkFax();
            this.checkWholeNumber();
            this.updateValues();
        },

        /**
         * Overriding submitForm and tracking Analytic event
         */
        submitForm() {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION);
            ws.views.form.prototype.submitForm.call(this);
        },

        /**
         * Validate fax number
         */
        checkFax: function () {
            if (this.$faxField.val()) {
                var regex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
                var fax;

                _.each(this.$faxField, function (field) {
                    fax = $(field).val();
                    if (regex.test(fax) === false) {
                        this.error = true;
                        $(field).addClass(this.errorClass);
                        if (!$(field).nextAll(this.errorMsg).is(':visible')) {
                            $(field).nextAll(this.customErrorMsg).show();
                        }
                    }
                }.bind(this));
            }
        },

        checkWholeNumber: function () {
            var regex = /^\d+$/;
            var wholeNumber;
            _.each(this.$wholeNumberField, function (field) {
                wholeNumber = $(field).val();
                if (regex.test(wholeNumber) === false) {
                    this.error = true;
                    $(field).addClass(this.errorClass);
                    if (!$(field).nextAll(this.errorMsg).is(':visible')) {
                        $(field).nextAll($('.custom-error-message')).show();
                    }
                }
            }.bind(this));
        },

        /**
         * Reset field with error message
         * @param {Object} e
         */
        resetField: function (e) {
            var $el = $(e.currentTarget);
            $el.removeClass(this.errorClass);
            $el.nextAll(this.errorMsg).hide();
            $el.nextAll(this.customErrorMsg).hide();
        },

        /**
         * Populate address fields if user selects address from address book
         * @param {Object} ev - Event object provided by the browser
         */
        onSelectAddressBookChanged: function (ev) {
            var $container = $(ev.currentTarget).parents('.comp-shipping');
            var $addressBookList = $container.find('#addressBook');
            var $newAddressCountryList = $container.find('#newAddressContainer #country');

            // this.$addressTypeFieldsets = $container.find('.address-type-fieldset');

            if ($addressBookList.val()) {
                this.$addressTypeFieldsets.prop('disabled', false);
                this.$addressTypeFieldsets.find('select').prop('disabled', false);

                this.$addressTypeFieldsets.find('#saveToAddressBook').prop('disabled', true).val('false');
                this.$addressTypeFieldsets.find('#saveToAddressBook').parent().addClass('hide');

                var addressData = $addressBookList.find('option:selected').data('attr');
                var country = _.findWhere(addressData, {name: 'country'});

                // When Address Book has a value, show pre-filed fields to show details address.
                this.$newAddressContainer.show();

                // If country is not the currently selected country,
                // then it needs to fetch and update the list of states.
                if (country.value !== $newAddressCountryList.val()) {
                    this.fetchStates = $.Deferred();
                    $newAddressCountryList.val(country.value).trigger('change');
                    this.fetchStates.done(function () {
                        this.updateInputsWithAddressBookData(addressData, $container);
                    }.bind(this));
                } else {
                    this.updateInputsWithAddressBookData(addressData, $container);
                }
            } else {
                this.$addressTypeFieldsets.find('#saveToAddressBook').parent().removeClass('hide');
                this.$addressTypeFieldsets.find('#saveToAddressBook').prop('disabled', false).val('true');
            }
        },

        /**
         * Populate address fields if user selects address from address book
         * @param {Object} ev - Event object provided by the browser
         */
        onSelectPickUpAddressBookChanged: function (ev) {
            var $container = $(ev.currentTarget).parents('.comp-pickUp');
            var $addressBookList = $container.find('#pickUpAddressBook');
            var $newAddressCountryList = $container.find('#pickUpNewAddressContainer #country');

            // this.$addressTypeFieldsets = $container.find('.address-type-fieldset');

            if ($addressBookList.val()) {
                this.$addressTypeFieldsets.prop('disabled', false);
                this.$addressTypeFieldsets.find('select').prop('disabled', false);

                this.$addressTypeFieldsets.find('#pickUpSaveToAddressBook').prop('disabled', true).val('false');
                this.$addressTypeFieldsets.find('#pickUpSaveToAddressBook').parent().addClass('hide');

                var addressData = $addressBookList.find('option:selected').data('attr');
                var country = _.findWhere(addressData, {name: 'pickUpCountry'});

                // When Address Book has a value, show pre-filed fields to show details address.
                this.$newAddressContainer.show();

                // If country is not the currently selected country,
                // then it needs to fetch and update the list of states.
                if (country.value !== $newAddressCountryList.val()) {
                    this.fetchStates = $.Deferred();
                    $newAddressCountryList.val(country.value).trigger('change');
                    this.fetchStates.done(function () {
                        this.updateInputsWithPickUpAddressBookData(addressData, $container);
                    }.bind(this));
                } else {
                    this.updateInputsWithPickUpAddressBookData(addressData, $container);
                }
            } else {
                this.$addressTypeFieldsets.find('#pickUpSaveToAddressBook').parent().removeClass('hide');
                this.$addressTypeFieldsets.find('#pickUpSaveToAddressBook').prop('disabled', false).val('true');
            }
        }
    });

}(westcon));
